import React, {FC, useState} from "react";
import {useTranslation} from "react-i18next";

interface BPProps {
    initPaystack?: () => void;
    makeMarketVisible?: () => void;
    setHidePaystack: () => void;
    isAuth: boolean;
    styles: any
    conditions?: any
    placeholder: string,
    handleChangeNumber: (number: string) => void,
}
const PystackPayments:FC <BPProps> = ({initPaystack, styles, makeMarketVisible,setHidePaystack, handleChangeNumber, placeholder,isAuth, conditions}) => {
    const [isPaystack, setIsPaystack] = useState(false);
    const { t } = useTranslation();
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    return (
        <>
            {
                isAuth ?
                    <div className='paystack-wrapper card-rounded position-relative card-px rounded mt-3'
                         style={{border: `1px solid ${styles.colors.fontColor}`}}>
                        <button
                            onClick={initPaystack}
                            style={{
                                backgroundColor: styles.colors.buttonBGColor,
                                color: '#000',
                                fontSize: styles.fonts.buttonFontSize,
                                fontFamily: styles.fonts.titleFontFamily,
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                width: '80%',
                                maxWidth: '410px',
                                margin: '0 auto',
                                display: 'block',
                            }}
                            className='btn mt-3 mb-3 paystack-init p-3'
                        >
                            <img className='paystack-logo'
                                 src={toAbsoluteUrl('/assets/img/paystack/paystack-logo.webp')}
                                 alt="paystack"
                                 style={{height: 'auto', width: '100%',}}
                            />
                        </button>
                    </div>
                    :
                    <div className='paystack-wrapper card-rounded position-relative card-px rounded mt-3'
                         style={{border: `1px solid ${styles.colors.fontColor}`}}>
                        {
                            !isPaystack ?
                                <div className="card-body p-3">
                                    <h2
                                        className='text-center rounded title p-1'
                                        style={{
                                            color: styles.colors.fontTitleColor,
                                            fontSize: styles.fonts.titleFontSize,
                                            fontFamily: styles.fonts.titleFontFamily,
                                            backgroundColor: styles.colors.blockTitleBgColor,
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        {t('paystack.title')}
                                    </h2>
                                    {
                                        conditions && conditions !== undefined && Object.keys(conditions).length > 0 ?
                                            <button
                                                onClick={initPaystack}
                                                disabled={conditions.total_odds < conditions.minTicketOdds}
                                                style={{
                                                    backgroundColor: '#f7ff99',
                                                    color: '#000',
                                                    fontSize: styles.fonts.buttonFontSize,
                                                    fontFamily: styles.fonts.titleFontFamily,
                                                    fontWeight: 'bold',
                                                    textTransform: 'uppercase',
                                                    width: '80%',
                                                    margin: '0 auto',
                                                }}
                                                className='btn mt-2 paystack-init p-2'
                                            >
                                                {t('brite.playNow')}
                                            </button>
                                            :
                                            <>
                                                <button
                                                    onClick={setHidePaystack}
                                                    style={{
                                                        backgroundColor: styles.colors.buttonBGColor,
                                                        color: '#000',
                                                        fontSize: styles.fonts.buttonFontSize,
                                                        fontFamily: styles.fonts.titleFontFamily,
                                                        fontWeight: 'bold',
                                                        textTransform: 'uppercase',
                                                        width: '80%',
                                                        maxWidth: '410px',
                                                        margin: '0 auto',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                    }}
                                                    className='btn mt-2 paystack-init p-1'
                                                >
                                                    <div style={{fontSize: '14px', margin: '0 auto'}}>
                                                        {t('paystack.mobileMoney')}
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-around',
                                                            marginTop: '5px'
                                                        }}>
                                                        <img
                                                            src={toAbsoluteUrl('/assets/operator/momo.webp')}
                                                            alt="momo"
                                                            style={{
                                                                height: 'auto',
                                                                width: '20%',
                                                            }}
                                                        />
                                                        <img
                                                            src={toAbsoluteUrl('/assets/operator/airtel.webp')}
                                                            alt="airtel"
                                                            style={{
                                                                height: 'auto',
                                                                width: '20%',
                                                            }}
                                                        />
                                                    </div>
                                                </button>
                                                <button
                                                    onClick={() => setIsPaystack(prevState => !prevState)}
                                                    style={{
                                                        backgroundColor: styles.colors.buttonBGColor,
                                                        color: '#000',
                                                        fontSize: styles.fonts.buttonFontSize,
                                                        fontFamily: styles.fonts.titleFontFamily,
                                                        fontWeight: 'bold',
                                                        textTransform: 'uppercase',
                                                        width: '80%',
                                                        maxWidth: '410px',
                                                        margin: '0 auto',
                                                        display: 'block',
                                                    }}
                                                    className='btn mt-2 paystack-init p-3'
                                                >
                                                    <img className='paystack-logo'
                                                         src={toAbsoluteUrl('/assets/img/paystack/paystack-logo.webp')}
                                                         alt="paystack"
                                                         style={{height: 'auto', width: '100%',}}
                                                    />
                                                </button>
                                            </>
                                    }
                                    {
                                        conditions && conditions.total_odds < conditions.minTicketOdds ? (
                                            <div style={{color: 'red'}}>
                                                {t('notifications.notEnoughOdds')}
                                            </div>
                                        ) : null
                                    }
                                    {
                                        makeMarketVisible ?
                                            <p
                                                className="mt-3 text-center fs-6"
                                                onClick={makeMarketVisible}
                                            >
                                                {t('quickbet.priceBlock.changeBet')}
                                            </p>
                                            : null
                                    }
                                </div>
                                :
                                <div className="card-body p-3">
                                    <p
                                        style={{
                                            color: styles.colors.fontColor,
                                            textAlign: 'center',
                                        }}
                                    >
                                        Enter the phone number linked to your bank account
                                    </p>
                                    <div className="input-group">
                                        <input
                                            style={{
                                                "--placeholder-color": styles.colors.fieldsFontColor,
                                                backgroundColor: styles.colors.fieldsBgColor,
                                                color: styles.colors.fieldsFontColor,
                                                borderRadius: '5px',
                                                display: 'block'
                                            } as React.CSSProperties}
                                            className="form-control custom-placeholder"
                                            type="tel"
                                            id="tel"
                                            required
                                            maxLength={12}
                                            minLength={9}
                                            name="msisdn"
                                            placeholder={placeholder}
                                            onChange={(e) => handleChangeNumber(e.target.value)}
                                        />
                                    </div>
                                    <button
                                        onClick={initPaystack}
                                        style={{
                                            backgroundColor: styles.colors.buttonBGColor,
                                            color: '#000',
                                            fontSize: styles.fonts.buttonFontSize,
                                            fontFamily: styles.fonts.titleFontFamily,
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            width: '80%',
                                            maxWidth: '410px',
                                            margin: '0 auto',
                                            display: 'block',
                                        }}
                                        className='btn mt-3 paystack-init p-3'
                                    >
                                        <img className='paystack-logo'
                                             src={toAbsoluteUrl('/assets/img/paystack/paystack-logo.webp')}
                                             alt="paystack"
                                             style={{height: 'auto', width: '100%',}}
                                        />
                                    </button>
                                    <div
                                        style={{
                                            marginTop: '15px',
                                            textTransform: 'uppercase',
                                            textDecoration: 'underline',
                                            textAlign: 'center',
                                        }}
                                        onClick={() => setIsPaystack(prevState => !prevState)}
                                    >
                                        {t('paystack.changeMethod')}
                                    </div>
                                </div>
                        }
                    </div>
            }
        </>
    )
};

export default PystackPayments;